<div *ngIf="!isPageReady" class="flex items-center justify-center h-full">
  <div class="flex flex-col items-center gap-3">
    <i class="pi pi-spin pi-spinner" style="font-size: 3rem; color: var(--p-primary-color);"></i>
    <span class="text-lg text-gray-600">Loading report data...</span>
  </div>
</div>

<div *ngIf="isPageReady" id="printable-open-jo-detail" class="h-full flex">
  <div class="no-print p-2 grow flex flex-col border-2 shadow-lg" style="max-width: 11in; min-width: 11in">

    <div *ngIf="shippingAddressGroups.length === 0" #printableArea class="screen-p-20">
      <h2>No open job order details found.</h2>
    </div>

    <div *ngIf="shippingAddressGroups.length > 0" #printableArea class="screen-p-20 grow" style="overflow: auto">

      <!-- Report Header -->
      <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 12px;">
        <div>
          <div style="font-size: 14pt; font-weight: bold;">Open Job Order Detail</div>
          <div style="font-size: 9pt; margin-top: 4px;">
            Report date: {{ timestamp }}
          </div>
          <div style="font-size: 10pt; margin-top: 2px;">
            Filter: For account: {{ accountName }}
          </div>
        </div>
      </div>

      <!-- Per-Shipping-Address Groups -->
      <ng-container *ngFor="let sg of shippingAddressGroups; let first = first">
        <div *ngIf="!first" class="break"></div>

        <!-- Shipping Address Header -->
        <div style="font-size: 11pt; font-weight: bold; margin-top: 12px; margin-bottom: 4px;
                     border-bottom: 2px solid #333; padding-bottom: 2px;">
          Ship To: {{ sg.shippingName }}
        </div>
        <div style="font-size: 9pt; margin-bottom: 8px; color: #555;">
          {{ sg.shippingAddress1 }}
          <span *ngIf="sg.shippingAddress2">, {{ sg.shippingAddress2 }}</span>
          <span *ngIf="sg.shippingAddress3">, {{ sg.shippingAddress3 }}</span>
          &nbsp;&mdash;&nbsp;
          {{ sg.shippingCity }}, {{ sg.shippingState }} {{ sg.shippingZipCode }}
        </div>

        <!-- Per-JO Groups -->
        <ng-container *ngFor="let jg of sg.joGroups">

          <!-- JO Sub-Header -->
          <div style="display: flex; justify-content: space-between; align-items: center;
                       font-size: 9pt; font-weight: bold; margin-top: 10px; margin-bottom: 2px;
                       background-color: #f0f0f0; padding: 3px 6px;">
            <div>
              {{ jg.joHeader.id }}
              &nbsp;&nbsp;
              {{ jg.joHeader.joDate | date:'M/d/yyyy' }}
              &nbsp;&nbsp;
              Exp Ship: {{ jg.joHeader.origExpectedShipDate | date:'M/d/yyyy' }}
            </div>
            <div>
              {{ jg.joHeader.getFormalEmployeeName() }}
            </div>
          </div>

          <!-- Actions label -->
          <div style="font-size: 8pt; font-style: italic; margin-left: 6px; margin-bottom: 1px;">
            Actions :
          </div>

          <!-- Detail Table -->
          <table class="grid-print" style="table-layout: fixed; width: 100%;">
            <colgroup>
              <col style="width: 13%;">
              <col style="width: 12%;">
              <col style="width: 16%;">
              <col style="width: 12%;">
              <col style="width: 5%;">
              <col style="width: 5%;">
              <col style="width: 5%;">
              <col style="width: 5%;">
              <col style="width: 8%;">
              <col style="width: 19%;">
            </colgroup>
            <thead>
              <tr>
                <th class="col-left">Manufacturer</th>
                <th class="col-left">SKU</th>
                <th class="col-left">Description</th>
                <th class="col-left">Features</th>
                <th class="col-right">Ord'd</th>
                <th class="col-right">Cnl'd</th>
                <th class="col-right">Ship</th>
                <th class="col-right">Open</th>
                <th class="col-left">Exp Ship</th>
                <th class="col-left">Bin #</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of jg.rows">
                <td>{{ row.manufacturer }}</td>
                <td>{{ row.sku }}</td>
                <td>{{ row.description }}</td>
                <td>{{ row.features }}</td>
                <td class="col-right">{{ row.orderedQty }}</td>
                <td class="col-right">{{ row.cancelledQty }}</td>
                <td class="col-right">{{ row.shippedQty }}</td>
                <td class="col-right">{{ row.openQty }}</td>
                <td>{{ row.expectedShipDate }}</td>
                <td>{{ row.binNumber }}</td>
              </tr>
            </tbody>
          </table>

        </ng-container>
      </ng-container>
    </div>

    <!-- Screen-only action bar -->
    <div uni-flex-row class="accent no-print mt-4">
      <div>
        <button pButton type="button" class="p-button-raised"
                [disabled]="shippingAddressGroups.length === 0"
                (click)="printDocument()">
          <span>Print PDF</span>
        </button>
      </div>
    </div>
  </div>
</div>
